export default __webpack_public_path__ + "a2a8c5d6f899e89092524f44952ffb5a.jpg";